import React, { Component } from 'react';
import Recommend from './Recommend'
import Col from 'react-bootstrap/Col'

const SKIP_QUIZ_ACCESSED = 1000 * 60 * 60 * 12

export async function getIncompletedTasks(db, uid, taskRef, allTaskRefs, checked) {
  const taskDataRef = await db.collection('task').doc(taskRef.id).get()
  if (!taskDataRef.exists) {
    console.error('No tasks', taskRef.id)
    return taskRef.data().completed ? [] : [taskRef]
  }
  const links = taskDataRef.data().links
  if (!links) {
    console.error('No links', taskRef.id)
    return taskRef.data().completed ? [] : [taskRef]
  }
  const linksObj = JSON.parse(links)
  if (!(linksObj.previous && linksObj.previous.task && linksObj.previous.url)) {
    console.error('No previous tasks', taskRef.id)
    return taskRef.data().completed ? [] : [taskRef]
  }
  const previousTaskId = linksObj.previous.url.match(/^.*task_id=([a-zA-Z0-9]+).*/)[1]
  if (!previousTaskId) {
    console.error('Unexpected URL', linksObj.previous.url)
    return taskRef.data().completed ? [] : [taskRef]
  }
  if ((checked || []).includes(previousTaskId)) {
    console.error('Already checked tasks', previousTaskId)
    return taskRef.data().completed ? [] : [taskRef]
  }
  const nextChecked = (checked || []).concat([previousTaskId])
  const previousTaskRefs = allTaskRefs
    .filter((taskRef) => taskRef.id === previousTaskId)
  let previousTaskRef = {
    id: previousTaskId,
    data: () => ({
      valid: false,
      accessed: 0,
      title: linksObj.previous.title || previousTaskId,
      completed: false,
      rate: 0.0,
      score: 0,
      scoreTotal: 0,
      quizAccessed: null,
      lastContext: null,
    })
  }
  if (previousTaskRefs.length > 0) {
    previousTaskRef = previousTaskRefs[0]
  }
  const previousIncompleted = await getIncompletedTasks(
    db, uid, previousTaskRef, allTaskRefs, nextChecked
  )
  if (previousIncompleted.length === 0) {
    return taskRef.data().completed ? [] : [taskRef]
  }
  return previousIncompleted
}

export async function getRecommendedQuizs(db, uid, taskRefs, maxRecommend, currentTime) {
  const targetTaskRefs = taskRefs
    .filter((taskRef) => taskRef.data().quizAccessed === null || taskRef.data().quizAccessed === undefined
      || currentTime.getTime() - taskRef.data().quizAccessed >= SKIP_QUIZ_ACCESSED)
  return targetTaskRefs.slice(0, maxRecommend)
}

export async function getRecommendedTasks(db, uid, taskRefs, maxRecommend, currentTime) {
  const candidateTaskRefs = taskRefs.slice(0, maxRecommend)
  const incompletedTasks = await Promise.all(candidateTaskRefs
    .map((taskRef) => getIncompletedTasks(db, uid, taskRef, taskRefs)))
  const recommendedTasks = []
  incompletedTasks.forEach((tasks) => {
    tasks.forEach((task) => {
      if (recommendedTasks
        .filter((rTaskRef) => rTaskRef.id === task.id).length > 0) {
        return
      }
      recommendedTasks.push(task)
    })
  })
  return recommendedTasks
}

export class Recommends extends Component {
  render() {
    return (this.props.items || []).map((item) =>
      <Col md='6'>
        <Recommend
          key={item.id}
          type={this.props.type}
          baseURL={this.props.baseURL}
          item={item}
          imgsrc={(this.props.images || {})[item.id]}
        />
      </Col>)
  }
}
